import React, { useState, useEffect } from 'react';
import Styles from '../Login.module.scss';
import { Form, FormGroup } from 'reactstrap';
import PasswordInput from '../../common/PasswordInput';
import { useTranslation } from 'react-i18next';

export interface OwnProps {
  error: string;
  onFieldValueChange?: () => void;
  onSetupPassword: (password: string, repeatPassword: string) => void;
}

type Props = OwnProps;

export const SetPassword: React.FC<Props> = ({ error, onFieldValueChange, onSetupPassword }) => {
  const [password, setPassword] = useState<string>('');
  const [confirmedPassword, setConfirmedPassword] = useState<string>('');
  const [submitEnabled, setSubmitEnabled] = useState<boolean>(false);
  const i18n = useTranslation();

  useEffect(() => {
    setSubmitEnabled(password.length > 0 && confirmedPassword.length > 0);
  }, [password, confirmedPassword]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSetupPassword(password, confirmedPassword);
  };
  const handlePasswordChange =
    (key: 'password' | 'confirmedPassword') => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      if (key === 'password') {
        setPassword(value);
      } else {
        setConfirmedPassword(value);
      }

      if (onFieldValueChange) {
        onFieldValueChange();
      }
    };

  return (
    <div className={Styles.loginWithAccount}>
      <div className={Styles.loginFormWithTitle}>
        <div className={Styles.header}>{i18n.t('Login_SetPassword_Title')}</div>

        {error && <div className={Styles.error}>{error}</div>}
        <Form
          onSubmit={handleSubmit}
          className={Styles.loginFormContainer}
          spellCheck={false}
          autoCorrect="off"
        >
          <FormGroup>
            <div className={Styles.inputsWrapper}>
              <div>
                <label htmlFor="password" className={Styles.inputLabel}>
                  {i18n.t('Login_Password')}
                </label>
                <PasswordInput
                  value={password}
                  className={Styles.inputTextBox}
                  name="password"
                  id="password"
                  onChange={handlePasswordChange('password')}
                />
                <label htmlFor="confirmedPassword" className={Styles.inputLabel}>
                  {i18n.t('Login_RepeatPassword')}
                </label>
                <PasswordInput
                  value={confirmedPassword}
                  className={Styles.inputTextBox}
                  name="confirmedPassword"
                  id="confirmedPassword"
                  onChange={handlePasswordChange('confirmedPassword')}
                />
              </div>
              <div>
                <button type="submit" className={Styles.submitButton} disabled={!submitEnabled}>
                  {i18n.t('Login_ResetPasswordButton')}
                </button>
              </div>
            </div>
          </FormGroup>
        </Form>
      </div>
    </div>
  );
};
